import React, { useState, useEffect, useCallback } from "react";

const ViewOption = ({ data, selected, onOptionSelect }) => {
    const [options, setOptions] = useState(false);

    const updateOption = useCallback(() => {
        const opts = [];
        if (data && data.length > 0) {
            data.forEach((d) => opts.push({ name: d.name, value: d.id }));
        }
        setOptions(opts);
    }, [data]);

    const onSlected = (e) => {
        if (onOptionSelect) {
            onOptionSelect(e.target.value);
        }
    };

    useEffect(() => {
        updateOption();
        return () => {};
    }, [updateOption]);

    const val = selected;

    if (options && options.length > 0) {
        return (
            <select className="form-control form-control-sm" name="view-select" value={val} onChange={(e) => onSlected(e)}>
                {options.map((option) => {
                    return (
                        <option key={`view-option-${option.value}`} value={option.value}>
                            {option.name}
                        </option>
                    );
                })}
            </select>
        );
    } else {
        return <></>;
    }
};

export default ViewOption;
